import { render, staticRenderFns } from "./CandidateScorecardIcon.vue?vue&type=template&id=4d7b616a"
import script from "./CandidateScorecardIcon.vue?vue&type=script&lang=js"
export * from "./CandidateScorecardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports